import { Injectable } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UlaValidators } from '../../common-library/validators/ula-validators';
import { FormValidationService } from '../fork-common-controls/form-validation.service';

@Injectable()
export class EmailPromptFormProvider {
  private static emailPromptForm: FormGroup = null;

  constructor(
    private formBuilder: FormBuilder,
    private formValidationService: FormValidationService) {

    if (!EmailPromptFormProvider.emailPromptForm) {
      EmailPromptFormProvider.emailPromptForm = this.formBuilder.group({
        firstName: ['', UlaValidators.getAllFirstAndLastNameValidators_PLFlows(formValidationService)],
        lastName: ['', UlaValidators.getAllFirstAndLastNameValidators_PLFlows(formValidationService)],
        email: ['', UlaValidators.getAllEmailValidators(formValidationService)],
        phone: ['', UlaValidators.getAllPhoneValidators(formValidationService)],
        details: ['', Validators.required]
      });
    }
  }

  isValid(): boolean {
    // temporary implementation to facilitate demo
    return true;

    // return EmailPromptFormProvider.emailPromptForm.valid;
  }

  getForm(): FormGroup {
    return EmailPromptFormProvider.emailPromptForm;
  }
}
